import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ isAuthenticated, component: Component, ...rest }) => (
  <div className="h-100">
    <Route
      {...rest}
      component={(props) =>
        isAuthenticated ? (
          <Redirect to="/Home" />
        ) : (
          <Component {...props} />
        )
      }
    />
  </div>
);

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(PublicRoute);
